import { all, call, put, takeLatest } from 'redux-saga/effects'

import apiEndPoints from '@/consts/apiEndPoints'
import api from '@/services/api'
import handleErrors from '@/services/handleErrors'

import { getCarrierVehiclesRequest, getCarrierVehiclesReply } from './reducer'

function* getVehicles() {
  try {
    const response = yield call(api.get, apiEndPoints.vehicles.root)

    const vehicles = response.data

    yield put(getCarrierVehiclesReply({ vehicles }))
  } catch (error) {
    handleErrors(error, 'Não foi possível buscar os veículos')
    yield put(getCarrierVehiclesReply())
  }
}

export default all([takeLatest(getCarrierVehiclesRequest.type, getVehicles)])
